type Tabs1Options = {
  rootSelector?: string;
  btnSelector?: string;
  boxSelector?: string;
  activeClass?: string;
};

export function initTabs1({
  rootSelector = '.js-tabs-1',
  btnSelector = '.js-tabs-1-btn',
  boxSelector = '.js-tabs-1-box',
  activeClass = 'active'
}: Tabs1Options = {}): void {
  const tabs = document.querySelectorAll<HTMLElement>(rootSelector);
  if (!tabs.length) return;

  tabs.forEach(tab => {
    const btns = tab.querySelectorAll<HTMLElement>(btnSelector);
    const boxes = tab.querySelectorAll<HTMLElement>(boxSelector);

    if (!btns.length || !boxes.length) return;
    if (btns.length !== boxes.length) return;

    const clearActive = (): void => {
      btns.forEach(btn => btn.classList.remove(activeClass));
      boxes.forEach(box => box.classList.remove(activeClass));
    };

    btns.forEach((btn, index) => {
      const box = boxes[index];
      if (!box) return;

      btn.addEventListener('click', () => {
        clearActive();
        btn.classList.add(activeClass);
        box.classList.add(activeClass);
      });
    });

    clearActive();
    btns[0].classList.add(activeClass);
    boxes[0].classList.add(activeClass);
  });
}
